import { HTTP_METHODS } from '@/utils/constants/httpMethods'

export const REWARDS_CONFIG = {
  REWARD_TYPES: {
    endPoint: 'dropdown-config?dropdownName=rewardTypes',
    method: HTTP_METHODS.GET,
  },
  REWARD_SEGMENTS: {
    endPoint: 'dropdown-config?dropdownName=rewardSegments',
    method: HTTP_METHODS.GET,
  },
  SAVE_DRAFT: {
    endPoint: 'rewards',
    method: HTTP_METHODS.POST,
  },
  PUBLISH_REWARD: {
    endPoint: 'rewards',
    method: HTTP_METHODS.POST,
  },
  GET_REWARD_DETAIL: (id) => ({
    endPoint: `rewards/${id}`,
    method: HTTP_METHODS.GET,
  }),
  UPDATE_REWARD: {
    endPoint: 'rewards',
    method: HTTP_METHODS.PUT,
  },
  DELETE_REWARD: (id) => ({
    endPoint: `rewards/${id}`,
    method: HTTP_METHODS.DELETE,
  }),
  SEGMENTS_LIST: (queryParams) => ({
    endPoint: `user/segments/list?${queryParams}`,
    method: HTTP_METHODS.POST,
  }),
  DIGITAL_CODES_LIST: (queryParams) => ({
    endPoint: `rewards/digital-codes/list?${queryParams}`,
    method: HTTP_METHODS.POST,
  }),
}
